// extracted by mini-css-extract-plugin
export default {"postsContainer":"betKursNovo_postsContainer__TrUi7"};